import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap-daterangepicker/daterangepicker.css";
import Chart from "react-apexcharts";
// import ReactApexChart from 'react-apexcharts';
import { Doughnut } from "react-chartjs-2";
// import ApexCharts from 'react-apexcharts';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import TabsComponent from "./tabs";
import { ROLL_CALL_API_BASE_URL } from "../RollCallConfig/RollCallConfig";
import { DatePicker, Spin } from "antd";
import dayjs from "dayjs";
import "antd/dist/reset.css";
import { CalendarOutlined } from "@ant-design/icons";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
);

const RollcallDashboard = () => {
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [dashboardCount, setDashboardCount] = useState([]);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [graphsData, setgraphsData] = useState([]);
  const [salesDayChart, setSalesDayChart] = useState(null);
  const [graphLoading, setGraphLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchTabsPresentData = async () => {
        setGraphLoading(true);

        const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
        console.log(
          selectedDate,
          "selectedDate",
          formattedDate,
          "formattedDate",
        );
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/Attendance/getAttendancebystatusoflast7days?SuperId=${superIdData}&currentdates=${formattedDate}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );
          const data = await response.json();

          if (data["status"]) {
            setgraphsData(data.ResultData);
          } else {
            console.error("Failed to fetch data:", response.statusText);
          }
        } catch (error) {
          console.error("Error fetching data:", error.message);
        } finally {
          setGraphLoading(false);
        }
      };
      fetchTabsPresentData();
    }
  }, [selectedDate, superIdData, tokenData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
      const fetchTabsData = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/Dashboard/getdashboardcount?superid=${superIdData}&selectedDate=${formattedDate}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );
          const data = await response.json();

          if (data["status"]) {
            setDashboardCount(data["ResultData"][0]);
          } else {
            console.error("Failed to fetch data:", response.statusText);
          }
        } catch (error) {
          console.error("Error fetching data:", error.message);
        }
      };

      fetchTabsData();
    }
  }, [selectedDate, tokenData, superIdData]);

  useEffect(() => {
    if (graphsData && graphsData?.length > 0) {
      const sortedData = [...graphsData].sort(
        (a, b) => new Date(a.Date) - new Date(b.Date),
      );

      const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      const categories = sortedData?.map((item) => {
        const date = new Date(item.Date);
        return days[date.getDay()];
      });

      const present = sortedData?.map((item) => item.PRESENT);
      const absent = sortedData?.map((item) => item.ABSENT);
      const late = sortedData?.map((item) => item.LATE);
      const leave = sortedData?.map((item) => item.LEAVE);

      setSalesDayChart({
        chart: {
          height: 245,
          type: "bar",
          stacked: true,
          toolbar: {
            show: false,
          },
        },
        colors: ["#81C784", "#EF9A9A", "#FFCC80", "#90CAF9"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        plotOptions: {
          bar: {
            borderRadius: 8,
            borderRadiusWhenStacked: "all",
            horizontal: false,
            endingShape: "rounded",
          },
        },
        series: [
          { name: "Present", data: present },
          { name: "Absent", data: absent },
          { name: "Late", data: late },
          { name: "On Leave", data: leave },
        ],
        xaxis: {
          categories,
          labels: {
            style: {
              colors: "#6B7280",
              fontSize: "13px",
            },
          },
        },
        yaxis: {
          title: {
            text: "Employee Count",
          },
          labels: {
            offsetX: -15,
            style: {
              colors: "#6B7280",
              fontSize: "13px",
            },
          },
        },
        grid: {
          borderColor: "#E5E7EB",
          strokeDashArray: 5,
          padding: {
            left: -16,
            top: 0,
            bottom: 0,
            right: 0,
          },
        },
        legend: {
          show: true,
          position: "top",
        },
        dataLabels: {
          enabled: false,
        },
        fill: {
          opacity: 1,
        },
      });
    } else {
      console.log("No data available for graph.");
    }
  }, [graphsData]);

  const data = {
    labels: ["Present", "Late", "Absent", "Leave"],
    datasets: [
      {
        label: "Attendance",
        data: [
          dashboardCount?.PRESENT || 0,
          dashboardCount?.LATE || 0,
          dashboardCount?.ABSENT || 0,
          dashboardCount?.LEAVE || 0,
        ],
        backgroundColor: ["#FE9F43", "#E04F16", "#092C4C", "#94e66c"],
        borderWidth: 5,
        borderRadius: 10,
        hoverBorderWidth: 4,
        cutout: "50%",
      },
    ],
  };

  const option = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: -20,
        bottom: -20,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: function (tooltipItems) {
            const index = tooltipItems[0].dataIndex;
            return data.labels[index];
          },
          label: function (tooltipItem) {
            const value = tooltipItem.raw;
            return ` ${value}`;
          },
        },
      },
    },
  };
  const total = (dashboardCount?.PRESENT || 0) + (dashboardCount?.LATE || 0);

  const getTodayDate = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0"); // months are 0-based
    const year = today.getFullYear();

    return `${day}/${month}/${year}`;
  };

  return (
    <div className="page-wrapper">
      {graphLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div className="content">
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-2">
          <div className="mb-3">
            <h1 className="mb-1">RollCall</h1>
            <p className="fw-medium">
              Total Employees in office{" "}
              <span className="text-primary fw-bold">{total}</span> , Today (
              {getTodayDate()})
            </p>
          </div>
          <div className="input-icon-start position-relative mb-3">
            <DatePicker
              size="small"
              suffixIcon={<CalendarOutlined />}
              format="DD-MM-YYYY"
              allowClear={false}
              value={selectedDate ? dayjs(selectedDate, "DD-MM-YYYY") : null}
              presets={[
                { label: "Today", value: dayjs() },
                { label: "Tomorrow", value: dayjs().add(1, "day") },
              ]}
              onChange={(date) => {
                setSelectedDate(date);
              }}
            />
            <span className="input-icon-addon">
              <i className="ti ti-calendar fs- text-gray fs-4"></i>
            </span>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <Link
              to="/rollcall/registrations"
              className="card bg-secondary sale-widget flex-fill"
            >
              <div className="card-body d-flex align-items-center">
                <span className="sale-icon bg-white text-secondary">
                  <i className="ti ti-file-text fs-24" />
                </span>
                <div className="ms-2">
                  <p className="text-white mb-1"> Registrations</p>
                  <div className="d-inline-flex align-items-center flex-wrap gap-2">
                    <h4 className="text-white">
                      {dashboardCount?.TOTALREGISTRATIONS ?? 0}
                    </h4>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card bg-teal sale-widget flex-fill">
              <div className="card-body d-flex align-items-center">
                <span className="sale-icon bg-white text-teal">
                  <i className="fa-solid fa-user-check fa-lg"></i>
                </span>
                <div className="ms-2">
                  <p className="text-white mb-1"> Present</p>
                  <div className="d-inline-flex align-items-center flex-wrap gap-2">
                    <h4 className="text-white">
                      {dashboardCount?.PRESENT ?? 0}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card bg-primary sale-widget flex-fill">
              <div className="card-body d-flex align-items-center">
                <span className="sale-icon bg-white text-primary">
                  <i className="fa-solid fa-user-clock fa-lg"></i>
                </span>
                <div className="ms-2">
                  <p className="text-white mb-1"> Late</p>
                  <div className="d-inline-flex align-items-center flex-wrap gap-2">
                    <h4 className="text-white">{dashboardCount?.LATE ?? 0}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card bg-danger sale-widget flex-fill">
              <div className="card-body d-flex align-items-center">
                <span className="sale-icon bg-white text-danger">
                  <i className="fa-solid fa-user-xmark fa-lg"></i>
                </span>
                <div className="ms-2">
                  <p className="text-white mb-1"> Absent</p>
                  <div className="d-inline-flex align-items-center flex-wrap gap-2">
                    <h4 className="text-white">
                      {dashboardCount?.ABSENT ?? 0}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <>
            <div className="col-12 col-md-12 col-lg-8 d-flex">
              <div className="card flex-fill">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <div className="d-inline-flex align-items-center">
                    <span className="title-icon bg-soft-primary fs-16 me-2">
                      <i className="fa-solid fa-chart-simple"></i>{" "}
                    </span>
                    <h5 className="card-title mb-0">Attendance By Status </h5>
                  </div>
                </div>
                <div className="card-body pb-0">
                  <div>
                    <div id="sales-daychart mt-5">
                      {salesDayChart ? (
                        <Chart
                          options={salesDayChart}
                          series={salesDayChart.series}
                          type="bar"
                          height={370}
                        />
                      ) : (
                        <p>data Not Found...</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-12 col-lg-4 d-flex">
              <div className="card flex-fill">
                <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                  <div className="d-inline-flex align-items-center">
                    <span className="title-icon bg-soft-primary fs-16 me-2">
                      <i className="fa-solid fa-chart-pie"></i>{" "}
                    </span>
                    <h5 className="card-title mb-0">Attendance By Status</h5>
                  </div>
                </div>
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between flex-wrap gap-4 mb-4">
                    <div>
                      <Doughnut
                        data={data}
                        options={option}
                        style={{
                          boxSizing: "border-box",
                          height: "230px",
                          width: "200px",
                          marginLeft: "32px",
                        }}
                      />
                    </div>
                    <div>
                      <div className="category-item category-primary">
                        <p className="fs-13 mb-1">Present</p>
                        <h4 className="d-flex align-items-center">
                          {dashboardCount?.PRESENT}
                        </h4>
                      </div>
                      <div className="category-item category-orange">
                        <p className="fs-13 mb-1">Late</p>
                        <h4 className="d-flex align-items-center">
                          {dashboardCount?.LATE}
                        </h4>
                      </div>
                      <div className="category-item category-secondary">
                        <p className="fs-13 mb-1">Absent</p>
                        <h4 className="d-flex align-items-center">
                          {dashboardCount?.ABSENT}
                        </h4>
                      </div>
                      <div className="category-item category-success">
                        <p className="fs-13 mb-1">Leave</p>
                        <h4 className="d-flex align-items-center">
                          {dashboardCount?.LEAVE}
                        </h4>
                      </div>
                    </div>
                  </div>
                  <h6 className="mb-2">Attendance Statistics</h6>
                  <div className="border br-8">
                    <div className="d-flex align-items-center justify-content-between border-bottom p-2">
                      <p className="d-inline-flex align-items-center mb-0">
                        <i className="ti ti-square-rounded-filled text-indigo fs-8 me-2" />
                        Total Number of Presentees
                      </p>
                      <h5> {dashboardCount?.PRESENT}</h5>
                    </div>
                    <div className="d-flex align-items-center justify-content-between p-2">
                      <p className="d-inline-flex align-items-center mb-0">
                        <i className="ti ti-square-rounded-filled text-orange fs-8 me-2" />
                        Total on Leave
                      </p>
                      <h5> {dashboardCount?.LEAVE}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        </div>
        <TabsComponent selectedDate={selectedDate}></TabsComponent>
      </div>
      <div className="copyright-footer d-flex align-items-center justify-content-between border-top bg-white gap-3 flex-wrap">
        <p className="fs-13 text-gray-9 mb-0">
          2014-2026 © Pereco. All Right Reserved
        </p>
        <p>
          Designed &amp; Developed By{" "}
          <a
            href="https://perennialcode.in/"
            className="link-primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            Pereco
          </a>
        </p>
      </div>
    </div>
  );
};

export default RollcallDashboard;
